import type { TaskExample } from '@frontend/api-types';
import { CardContainer, Text } from '@frontend/web-react';
import { useAnalytics } from '@frontend/web/hooks';
import { useRouter } from '@frontend/web/utils';

type TrendingTaskCardProps = {
  example: TaskExample;
};

export const TrendingTaskCard = ({ example }: TrendingTaskCardProps) => {
  const { description, name } = example;
  const { track } = useAnalytics();
  const { navigate } = useRouter();

  const handleClick = async () => {
    track({
      data: { exampleId: example.id, exampleType: example.exampleType, taskName: example.name },
      event: 'exampleSelected',
      topic: 'examples',
    });

    navigate({
      search: { description, example: example.id, name },
      to: '/app/draft-task/create',
    });
  };

  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    <CardContainer className="gap-none justify-center p-lg border-[0.8px] border-neutral-200" onClick={handleClick}>
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <Text className="font-[500]" color="primary" lineClamp={2} type="p-md">
        {name}
      </Text>
    </CardContainer>
  );
};
